import { render, staticRenderFns } from "./ApplicantMessageRegisterForm.vue?vue&type=template&id=639539c4"
import script from "./ApplicantMessageRegisterForm.vue?vue&type=script&lang=js"
export * from "./ApplicantMessageRegisterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports